import {
  LuChartColumn, LuChartLine, LuCirclePlus, LuDownload, LuFileText, LuList, LuSmile,
} from 'react-icons/lu';
import { moduleTour as tour, OPTIONAL as opt } from '../defineTour';

// Landing-tab tour first; one tour per further tab below it.
const tours = [
  // exact: survey detail, create and responses pages live under /csat.
  tour('csat', '/csat', 'customer_satisfaction', [
    ['tabs', 'csat.tabs', LuSmile],
    ['kpis', 'csat.kpis', LuChartColumn, opt],
    ['surveys', 'csat.surveys', LuFileText, { placement: 'top', ...opt }],
  ], { exact: true }),

  // Viewers and Users are sent here from /csat, so this tour stands alone.
  tour('csat_surveys', '/csat/surveys', 'customer_satisfaction', [
    ['header', 'csat_surveys.header', LuSmile],
    ['create', 'csat_surveys.create', LuCirclePlus, { placement: 'left', ...opt }],
    ['list', 'csat_surveys.list', LuList, { placement: 'top', ...opt }],
  ], { exact: true }),

  tour('csat_reports', '/csat/reports', 'customer_satisfaction', [
    ['summary', 'csat_reports.summary', LuChartColumn],
    ['trend', 'csat_reports.trend', LuChartLine, { placement: 'top' }],
    ['export', 'csat_reports.export', LuDownload, { placement: 'left' }],
  ], { exact: true }),
];

export default tours;
